export default __webpack_public_path__ + "alberta-enterostomy.7d6d62cc1930f6784cf5.svg";